import React, { useMemo } from "react";
import { Link, useParams } from "react-router-dom";
import ArticleHeader from "../../components/pages/NewsDetails/ArticleHeader/ArticleHeader";
import ArticleBody from "../../components/pages/NewsDetails/ArticleBody/ArticleBody";
import ArticleAuthor from "../../components/pages/NewsDetails/ArticleAuthor/ArticleAuthor";
import RelatedNews from "../../components/pages/NewsDetails/RelatedNews/RelatedNews";
import { usePublicBlogPost } from "../../hooks/usePublicBlogPost";
import { getApiErrorMessage } from "../../utils/apiResponse";
import { formatBlogDate, mapBlogListItem } from "../../utils/blog";
import { resolveMediaUrl } from "../../utils/mediaUrl";
import { useLanguage } from "../../context/LanguageContext";
import "./NewsDetails.css";

const NewsDetails = () => {
  const { id } = useParams();
  const { language, meta } = useLanguage();
  const postQuery = usePublicBlogPost(id);

  const loading = postQuery.isPending && !postQuery.data;
  const error = postQuery.error ? getApiErrorMessage(postQuery.error) : "";
  const post = postQuery.data;
  const relatedPosts = useMemo(
    () => (post?.related || []).map((item) => mapBlogListItem(item, language)),
    [post, language]
  );

  if (loading) {
    return (
      <div className="news-details-page" dir={meta.dir}>
        <div className="news-details-page__missing">
          <p>Loading article…</p>
        </div>
      </div>
    );
  }

  if (error || !post) {
    return (
      <div className="news-details-page" dir={meta.dir}>
        <div className="news-details-page__missing">
          <h1>Article not found</h1>
          <p>{error || "The news article you are looking for does not exist."}</p>
          <Link to="/news">Back to news</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="news-details-page" dir={meta.dir}>
      <main className="news-details-page__main">
        <div className="news-details-page__container">
          <ArticleHeader
            category={post.category}
            date={formatBlogDate(post.publishedAtUtc, language)}
            title={post.title}
            image={resolveMediaUrl(post.coverImageUrl)}
          />
          <ArticleBody body={post.body} />
          <div className="news-details-page__author-wrap">
            <ArticleAuthor name={post.authorName} />
          </div>
        </div>
        <RelatedNews posts={relatedPosts} />
      </main>
    </div>
  );
};

export default NewsDetails;
